module.exports = __webpack_public_path__ + "static/face-tracking-for-homepage-67a0e609d580db1080f356a65a68cc15.mp4";